export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"},{"name":"name","content":"Jackpot city"},{"name":"google","content":"nopagereadaloud"},{"name":"applicationName","content":"JPC"},{"name":"rating","content":"adult"},{"name":"fb:app_id","content":"2764365053745524"},{"name":"og:image","content":"https://media.jpc.africa/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_500x500.jpg"},{"name":"og:image:secure_url","content":"https://media.jpc.africa/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_500x500.jpg"},{"name":"og:type","content":"website"}],"link":[{"rel":"icon","type":"image/png","href":"https://cms1.jpc.africa/medialibraries/content.gmgamingsystems.com/jackpotcity/branding/JPC_Favicon.png"}],"style":[],"script":[{"innerHTML":"`Ready`","tagPosition":"bodyOpen"}],"noscript":[],"htmlAttrs":{"class":"bg-base-secondary","translate":"no"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"remove","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true